import { Link } from "react-router-dom";

const LOGO_URL = "/media/anytime-vending-machines-logo.png";

export default function Logo({ className = "", testId = "site-logo", size = "md" }) {
  const sizeClass =
    size === "lg"
      ? "h-32 md:h-40"
      : size === "sm"
      ? "h-14"
      : "h-24 md:h-32";
  return (
    <Link
      to="/"
      data-testid={testId}
      className={`group inline-flex items-center ${className}`}
      aria-label="Anytime Vending Machines"
    >
      <img
        src={LOGO_URL}
        alt="Anytime Vending Machines"
        className={`${sizeClass} w-auto object-contain transition-transform duration-300 ease-out group-hover:scale-[1.04]`}
        draggable={false}
      />
    </Link>
  );
}
